<template>
  <div class="">
    <el-form
      ref="form"
      :model="form"
      label-width="110px"
    >
      <el-form-item label="手机设备编码">
        <el-input v-model="form.equipment_code" />
      </el-form-item>

      <el-form-item label="微信号">
        <el-input v-model="form.phone_vx_account" />
      </el-form-item>

      <el-form-item label="手机编号">
        <el-input v-model="form.phone_name" />
      </el-form-item>

      <el-form-item label="锁屏密码">
        <el-input v-model="form.lock_screen_password" />
      </el-form-item>

      <el-form-item label="微信密码">
        <el-input v-model="form.wechat_pwd" />
      </el-form-item>

      <el-form-item v-if="form.status" label="状态">
        <el-select v-model="form.status" placeholder="请选择">
          <el-option
            v-for="item in [{id: 1, value: '正常'}, {id: 2, value: '停用'}]"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button
          type="primary"
          @click="onSubmit"
        >立即创建</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    currentItem: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      form: {
        equipment_code: this.currentItem.equipment_code, // 手机设备编码
        phone_vx_account: this.currentItem.phone_vx_account, // 微信号
        phone_name: this.currentItem.phone_name, // 手机编号
        lock_screen_password: this.currentItem.lock_screen_password, // 锁屏密码
        wechat_pwd: this.currentItem.wechat_pwd, // 微信密码
        status: Object.keys(this.currentItem).length ? this.currentItem.status : undefined // 状态
      }
    }
  },
  created() {

  },
  methods: {
    onSubmit() {
      this.judge() && this.$emit('determine', this.form)
    },

    judge() {
      let text = null
      if (!this.form.equipment_code) {
        text = '请输入手机设备编码'
      } else if (!this.form.phone_vx_account) {
        text = '请输入微信号'
      } else if (!this.form.phone_name) {
        text = '请输入手机编号'
      } else if (!this.form.wechat_pwd) {
        text = '请输入微信密码'
      }

      text && this.$message({
        message: text,
        type: 'warning'
      })

      return !text
    }

  }
}
</script>

<style scoped>
.erBox {
  width: 100px;
  height: 100px;
  border: 1px solid #ccc;
  cursor: pointer;
  position: relative;
}

.erBox::before {
  content: '';
  position: absolute;
  width: 1px;
  height: 50px;
  background-color: #ccc;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.erBox::after {
  content: '';
  position: absolute;
  width: 50px;
  height: 1px;
  background-color: #ccc;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.erBox:hover{
   border-color: rgb(7, 123, 201);
}

.erBox:hover::after,.erBox:hover::before{
   background-color: rgb(7, 123, 201);
}

.file{
  display: none;
}

.imgBox{
   width: 100px;
   height: 100px;
   position: relative;
}

.imgBox:hover span{
   display: inline-block !important;
}

.imgBox span{
  width: 100%;
  height: 100%;
  background-color: rgba(200, 200, 200, 0.5);
  position: absolute;
  z-index: 11;
  left: 0px;
  display: none;
}

.myi{
    cursor: pointer;
    font-size: 25px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}
</style>
